import React, { useState } from 'react';
import { RefreshCw, PlayCircle } from 'lucide-react';
import { integrationsApi } from '../api/integrations';
import toast from 'react-hot-toast';

interface SyncButtonProps {
  projectId: string;
  provider: 'github' | 'notion' | 'asana' | 'jira';
  payload: any;
  label?: string;
  className?: string;
}

export const SyncButton: React.FC<SyncButtonProps> = ({ projectId, provider, payload, label = 'Sync', className = '' }) => {
  const [isSyncing, setIsSyncing] = useState(false);

  const handleSync = async () => {
    try {
      setIsSyncing(true);
      toast.loading(`Syncing to ${provider}...`, { id: 'sync' });
      await integrationsApi.syncToProvider(provider, projectId, payload);
      toast.success('Sync job enqueued successfully!', { id: 'sync' });
    } catch (error: any) {
      toast.error(error?.response?.data?.message || `Failed to sync to ${provider}`, { id: 'sync' });
    } finally {
      setIsSyncing(false);
    }
  };

  return (
    <button
      onClick={handleSync}
      disabled={isSyncing}
      className={`flex items-center gap-2 px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${
        isSyncing ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'bg-primary/10 text-primary hover:bg-primary/20'
      } ${className}`}
    >
      {isSyncing ? (
        <RefreshCw className="w-4 h-4 animate-spin" />
      ) : (
        <PlayCircle className="w-4 h-4" />
      )}
      {label}
    </button>
  );
};
